import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-jiantou_you",
  "use": "icon-jiantou_you-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-jiantou_you\"><defs><style type=\"text/css\"></style></defs><path d=\"M751.552 551.936l-399.232 399.232c-22.08 22.08-57.792 22.08-79.872 0-22.016-22.016-22.08-57.792 0-79.872l359.296-359.296-359.296-359.296c-22.016-22.016-22.08-57.792 0-79.872s57.792-22.016 79.872 0l399.232 399.232c22.016 22.08 22.016 57.792 0 79.872z\" p-id=\"7467\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol